import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import React from "react";
import withIntl from "../../../utils/withIntl";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { createArticles, updateArticle } from "../../../store/articles/ArticlesApi";
import articlesStore from "../../../store/articles/ArticlesStore";
import ControlPointDuplicateIcon from "@material-ui/icons/ControlPointDuplicate";
import cloudStore from "../../../store/CloudStore";
import { Article } from "../../../store/articles/models/Article";
import AuthorizationWrapper from "../../AuthorizationWrapper";

function ActionButtonArticles(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleDuplicateArticle = () => {
    console.log(props.article);
    let newArticle = Object.assign(new Article(), props.article);
    delete newArticle._id;
    delete newArticle.id;
    newArticle.name = "COPY_" + props.article.name;
    newArticle.plu = Math.max(...Object.keys(articlesStore.articles).map((key) => Number(articlesStore.articles[key].plu)).filter(a=>a)) + 1;
    createArticles(cloudStore.merchant.id, [newArticle]);
  };

  return (
    <div>
      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        variant="standard"
      >
        <BuildIcon colo={"primary"} />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            props.handleOpenArticleDetailsDialog();
            setAnchorEl(null);
          }}
        >
          <EditIcon color="primary" />
          {props.intl.formatMessage({ id: "edit_article" })}
        </MenuItem>
        <AuthorizationWrapper
          permission={"add_new_article"}
          child={
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                handleDuplicateArticle();
                setAnchorEl(null);
              }}
            >
              <ControlPointDuplicateIcon color={"primary"} />
              {props.intl.formatMessage({ id: "duplicate_article" })}
            </MenuItem>
          }
        />
        <AuthorizationWrapper
          permission={"delete_article"}
          child={
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                if (window.confirm(props.intl.formatMessage({ id: "are_you_sure_you_want_to_delete_article" }))) {
                  updateArticle(articlesStore.merchantId, props.article, { deletedAt: "deleted" });
                }
                setAnchorEl(null);
              }}
            >
              <DeleteIcon color="primary" />
              {props.intl.formatMessage({ id: "delete_article" })}
            </MenuItem>
          }
        />
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonArticles);
